import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  userAccountActivation,
  updateForgotPassword,
} from "../Utils/userFunctions";
import * as Constant from "../Utils/constants";
import {toast} from "react-toastify";
function ResetPaswordChnage() {
  const { userID, slugToken } = useParams();
  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [linkStatus, setLinkStatus] = useState(false);
  const [resetErrorMessage, setResetErrorMessage] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [loading,setLoading] = useState(false);

  useEffect(() => {
    checkAccountActivationLink();
  }, []);
  const checkAccountActivationLink = async () => {
    const response = await userAccountActivation(userID, slugToken);
    if (response.linkStatus == "not_expired") {
      setLinkStatus(true);
      setResetErrorMessage("");
    } else {
      setLinkStatus(false);
      setResetErrorMessage(response.message);
    }
  };
  const handleValidation = (event) => {
    const passwordInputValue = event.target.value.trim();
    const passwordLength = passwordInputValue.length;
    const uppercasePassword = Constant.UPPERCASE.test(passwordInputValue);
    const lowercasePassword = Constant.LOWERCASE.test(passwordInputValue);
    const digitsPassword = Constant.DIGITS.test(passwordInputValue);
    const specialCharPassword = Constant.SPECIALCHAR.test(passwordInputValue);
    const minLengthPassword = Constant.MINLENGTH.test(passwordInputValue);
    let errMsg = "";
    if (passwordLength === 0) {
      errMsg = "Password is empty";
    } else if (!uppercasePassword) {
      errMsg = "At least one Uppercase";
    } else if (!lowercasePassword) {
      errMsg = "At least one Lowercase";
    } else if (!digitsPassword) {
      errMsg = "At least one digit";
    } else if (!specialCharPassword) {
      errMsg = "At least one Special Characters";
    } else if (!minLengthPassword) {
      errMsg = "At least minumum 8 characters";
    }
    setPasswordErr(errMsg);
  };
  const handleResetPasword = async () => {
    
    const formData = new FormData();

    if (password.length === 0) {
      setPasswordErr("Password is empty");
    } else if (confirmPassword !== password) {
      setConfirmPasswordError("Confirm password is not matched");
    } else {
      setPasswordErr("");
      setConfirmPasswordError("");

      formData.append("user_id", userID);
      formData.append("reset_token", slugToken);
      formData.append("password", password);
      
      try{
        setLoading(true)
        const response = await updateForgotPassword(formData);
        if (response.status === "success") {
          setResetSuccess(true);
        } else {
          setResetSuccess(false);
        }
      }
      catch(error){
        toast.error(error.message)
      }
      finally{
        setLoading(false)
      }
     
    }
  };
  return (
    <div className="row gx-0">
      <div className="col-md-4 col-lg-4 col-sm-12 offset-md-4 mt-5">
        <div className="logo">
          <img
            src={require("../Assets/Images/logo.png")}
            alt="N/A"
            height="100"
          />
        </div>
        {linkStatus && resetSuccess === false ? (
          <>
            <div className="we-heading">
              <h2 className="text-center">
                <b>Set New Password</b>
              </h2>
            </div>
            <div className="we-form-box">
              <div className="auth-form">
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordErr("");
                    }}
                    onKeyUp={handleValidation}
                    placeholder="New Password *"
                    autoFocus
                  ></input>
                  <p style={{ color: "red" }}>{passwordError}</p>
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setConfirmPasswordError("");
                    }}
                    placeholder="Confirm Password *"
                  ></input>
                  <p style={{ color: "red" }}>{confirmPasswordError}</p>
                </div>
                <div className="form-group no-margin mt-5">
                  <button className="auth-btn" disabled={loading} onClick={handleResetPasword}>
                    {loading?"Loading...":"Reset Password"}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {resetErrorMessage && (
              <p className="text-center">{resetErrorMessage}</p>
            )}
            {resetSuccess && (
              <>
                <div className="we-heading text-center mt-5">
                  <h2 className="mb-2">Password Changed!</h2>
                </div>
                <p className="text-center my-3 mx-4">
                  Your password has been changed successfully.
                </p>
                <div className="form-group text-center mb-5 mt-4">
                  <Link to={"/login"} className="btn auth-btn">
                    Back to Login
                  </Link>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
export default ResetPaswordChnage;
